var oldTab;
$(document).ready(function () {
    $(window).trigger('hashchange');
});
$(window).on('hashchange', onBackClick);
function onBackClick(a, b, c) {
    var tab = $.bbq.getState("tab");
    //console.log('a: ' + JSON.stringify(a) + ", b:" + b + ", c:" + c);
    console.log("location hash = " + location.hash + " state: " + tab);
    // don't hide and show the same tab if nothing has changed.
    if (tab !== undefined && oldTab === tab)
        return;
    oldTab = tab;
    // hide them all then show the one.
    $(".mainContainer.visible").addClass("hidden").removeClass("visible").trigger('hidden');
    switch (tab) {
        case "home":
            $("#homeContainer").removeClass("hidden").addClass("visible");
            $("#homeContainer").trigger('visible');
            break;
        case "main":
            $("#mainContainer").removeClass("hidden").addClass("visible");
            $("#mainContainer").trigger('visible');
            break;
        case "duty":
            $("#dutyContainer").removeClass("hidden").addClass("visible");
            $("#dutyContainer").trigger('visible');
            break;
        default:
            $("#mainContainer").removeClass("hidden").addClass("visible");
            $("#mainContainer").trigger('visible');
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/router.ts
 ** module id = 31
 ** module chunks = 1
 **/